module.exports = {
      id: "live-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#live",
      toString: function () {
        return this.url;
      }
    }